import axios from "axios";
import baseUrl from "./url";
import { toast } from "react-hot-toast";
import { startProgress, setProgress, doneProgress } from "./progress.js";

import { getActiveRestaurantId, getActiveRestaurantSystemId } from "@/lib/idProvider";

const API = axios.create({
  baseURL: baseUrl,
});

const authInterceptor = (req) => {
  const token = localStorage.getItem("token");
  const clientInstance = localStorage.getItem("X-Client-Instance");
  const restaurantSystemId = getActiveRestaurantSystemId();
  const restaurantId = getActiveRestaurantId();

  if (token) req.headers.Authorization = `Bearer ${token}`;
  if (clientInstance) req.headers["X-Client-Instance"] = clientInstance;
  if (restaurantSystemId) req.headers["X-Restaurant-System-Id"] = restaurantSystemId;
  if (restaurantId) req.headers["X-Restaurant-Id"] = restaurantId;

  // Keep multipart boundary handling automatic for FormData uploads.
  if (req.data instanceof FormData) {
    delete req.headers["Content-Type"];
  } else {
    req.headers["Content-Type"] = "application/json";
  }

  return req;
};

const handleLogout = () => {
  toast.error("Session expired! Please login again.");
  localStorage.removeItem("token");
  setTimeout(() => {
    window.location.href = "/";
  }, 1500);
};

API.interceptors.request.use(
  (config) => {
    startProgress();
    return authInterceptor(config);
  },
  (error) => {
    doneProgress();
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => {
    doneProgress();
    return response;
  },
  (error) => {
    doneProgress();
    if (error.response?.status === 401) {
      handleLogout();
    }

    return Promise.reject(error);
  }
);

API.defaults.onDownloadProgress = function (progressEvent) {
  if (progressEvent.total) {
    const percent = Math.round(
      (progressEvent.loaded * 100) / progressEvent.total
    );
    setProgress(percent);
  }
};

API.defaults.onUploadProgress = function (progressEvent) {
  if (progressEvent.total) {
    const percent = Math.round(
      (progressEvent.loaded * 100) / progressEvent.total
    );
    setProgress(percent);
  }
};

export default API;

export const handleRequest = async (requestFn) => {
  try {
    const response = await requestFn();
    return response.data;
  } catch (error) {
    console.log(error);
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
